import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Shield, Cloud, Users, BarChart3 } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-24 lg:py-36" style={{ background: "var(--gradient-hero)" }}>
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-96 h-96 rounded-full bg-accent blur-3xl" />
        <div className="absolute bottom-10 right-20 w-[500px] h-[500px] rounded-full bg-accent blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-accent/20 text-accent border border-accent/20 mb-6">
              🎉 First 4 months free for all companies
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold font-display text-primary-foreground leading-tight mb-6"
          >
            Modern Cloud Accounting
            <br />
            <span className="text-accent">for India</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-primary-foreground/70 mb-10 max-w-2xl mx-auto leading-relaxed"
          >
            GST-compliant accounting software with built-in collaboration for CAs, Accountants &amp; Businesses. A powerful alternative to Tally ERP.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/dashboard">
              <Button size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 h-12 text-base shadow-elevated">
                Start Free Trial <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="border-accent/40 text-accent hover:bg-accent/10 h-12 text-base">
              Watch Demo
            </Button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-xs text-primary-foreground/50 mt-4"
          >
            No credit card required · Cancel anytime
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-2xl mx-auto"
        >
          {[
            { icon: Shield, label: "GST Compliant" },
            { icon: Cloud, label: "Cloud Based" },
            { icon: Users, label: "Multi-User" },
            { icon: BarChart3, label: "Real-time Reports" },
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-3 text-primary-foreground/80">
              <div className="w-12 h-12 rounded-xl bg-primary-foreground/10 flex items-center justify-center border border-primary-foreground/10">
                <item.icon className="h-5 w-5 text-accent" />
              </div>
              <span className="text-sm font-medium">{item.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
